import { ReactElement, useState } from 'react'
import { Button, Popover, Typography } from '@equinor/eds-core-react'
import styled from 'styled-components'
import Icon from '@/styles/icon'
import { getAccountInfo, signOut } from '@/api/AuthConfig'
import { close as closeIcon, account_circle as accountCircle } from '@equinor/eds-icons'
import { EdsStyledIcon } from '@/styles/layout'
import { useGetUserSettings } from '@/core/hooks-and-services/userSettingsService'
import PlantForm from '@/components/plantForm/PlantForm'

type Props = {
    onClose: () => void
    anchor: HTMLElement | null
}

function UserAccountMenu({ onClose, anchor }: Props): ReactElement {
    const [isOpen, setOpen] = useState<boolean>(true)
    const { data } = useGetUserSettings()
    const account = getAccountInfo()
    const displayName = account?.name ?? data?.userId

    const handleClose = () => {
        setOpen(false)
        onClose()
    }

    return (
        <Popover open={isOpen} anchorEl={anchor} onClose={handleClose}>
            <Popover.Header>
                <Popover.Title>User profile and settings</Popover.Title>
                <Button
                    style={{
                        height: '32px',
                        width: '32px',
                    }}
                    variant="ghost_icon"
                    aria-label="Close popover"
                    onClick={handleClose}
                >
                    <Icon data={closeIcon} size={24} />
                </Button>
            </Popover.Header>
            <Popover.Content>
                <UserStyle>
                    <StyledIcon data={accountCircle} size={24} />
                    <StyledTypography>{displayName}</StyledTypography>
                </UserStyle>
                <PlantForm onSaved={handleClose} />
                <ButtonContainer>
                    <Button
                        variant="ghost"
                        color="primary"
                        onClick={() => signOut()}
                        style={{ width: '112px', whiteSpace: 'nowrap' }}
                    >
                        <Icon name="logOut" />
                        Log out
                    </Button>
                </ButtonContainer>
            </Popover.Content>
        </Popover>
    )
}

const StyledTypography = styled(Typography)`
    font-family: Equinor;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
`

const UserStyle = styled.div`
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 4px;
`

const StyledIcon = styled(EdsStyledIcon)`
    color: #007079;
`

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 16px;
`

export default UserAccountMenu
